import { render, staticRenderFns } from "./FooterBox.vue?vue&type=template&id=c1a30daa&scoped=true&"
import script from "./FooterBox.vue?vue&type=script&lang=js&"
export * from "./FooterBox.vue?vue&type=script&lang=js&"
import style0 from "./FooterBox.vue?vue&type=style&index=0&id=c1a30daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a30daa",
  null
  
)

export default component.exports